export const INIT_ACTION_TYPE = 'APP_INIT' as const;
